<app-pan-button color="warning" [matMenuTriggerFor]="menu" [disabled]="disabled() || isSharing()" icon="send">
  Share

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="modal.show()">
      <span>Share to Specific Users</span>
    </button>
    <button mat-menu-item (click)="isGuestMode.set(true); modal.show()">
      <span>Share to All Guest Users</span>
    </button>
  </mat-menu>
</app-pan-button>

<swal
  #shareAllSwal
  title="Share With All Guest Users?"
  text="Are you sure you want to share this report with all guest users in this location? Confirming will grant all guest users access to this report."
  confirmButtonText="Yes, Share With All Guest Users"
  icon="warning"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="shareToAllGuestUsers()"
>
</swal>

<app-pan-modal #modal [topLevel]="false" (modalClose)="hide()">
  <div header>{{ modalTitle() }}</div>
  <div body>
    @if (!isGuestMode()) {
      <app-pan-form-control>
        <app-pan-floating-label>Users</app-pan-floating-label>
        <ng-select
          #emailInput
          placeholder="name@domain.com"
          bindLabel="email"
          class="share-email-input"
          [items]="userSearch.foundUsers()"
          [loading]="userSearch.isLoading()"
          [typeahead]="searchInput$"
          [multiple]="true"
          [clearable]="true"
          [addTag]="true"
          [(ngModel)]="usersToShare"
          (change)="validateUserToShare()"
        >
          <ng-template ng-option-tmp let-item="item">
            <p class="font-bold">{{ item.name }}</p>
            <p class="text-sm text-gray-600">{{ item.email }}</p>
          </ng-template>
        </ng-select>
      </app-pan-form-control>

      @if (emailError()) {
        <app-pan-inline-alert class="mt-2" type="danger" [label]="emailError()"></app-pan-inline-alert>
      }
    }

    <app-pan-form-control>
      <app-pan-floating-label>Message</app-pan-floating-label>
      <textarea panTextarea rows="6" [(ngModel)]="shareMessage" placeholder="Type your message here..."></textarea>
    </app-pan-form-control>

    <label>
      <input type="checkbox" panCheckbox [(ngModel)]="shareIncludeSelf" />
      Include me as a recipient
    </label>
  </div>

  <div footer class="space-x-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>

    @if (isGuestMode()) {
      <app-pan-button color="primary" [swal]="shareAllSwal"> Share </app-pan-button>
    } @else {
      <app-pan-button
        color="primary"
        (click)="onShare()"
        [disabled]="disabled() || usersToShare().length === 0 || isSharing()"
        [state]="isSharing() ? 'loading' : 'default'"
      >
        Share
      </app-pan-button>
    }
  </div>
</app-pan-modal>
